import { render, staticRenderFns } from "./charlie-plantillas.vue?vue&type=template&id=7faeb3ca"
import script from "./charlie-plantillas.vue?vue&type=script&lang=ts"
export * from "./charlie-plantillas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports